import { render, staticRenderFns } from "./PassionForm.vue?vue&type=template&id=e398f8ba&"
import script from "./PassionForm.vue?vue&type=script&lang=js&"
export * from "./PassionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports